module.exports = __webpack_public_path__ + "static/media/Icon-Others.44473d02.png";